module.exports = __webpack_public_path__ + "static/media/edit_wps_2.9f50431a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/edit_wps_2.jpg
// module id = 1907
// module chunks = 0